var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from '@serviceos-rn/core';
import { IContinueUseCaseType } from '../ContinueUseCase/IContinueUseCase';
import { ITipPayloadRepositoryType } from '../ITipPayloadRepository';
import { ITipRepositoryType } from '../ITipRepository';
import { ISetTipOptionUseCaseType } from '../SetTipOptionUseCase/ISetTipOptionUseCase';
import { ITipEventsRepositoryType } from '../ITipEventsRepository';
import { IGetAnalyticEventParamsUseCaseType } from '../GetAnalyticEventParamsUseCase/IGetAnalyticEventParamsUseCase';
import { ITipAnalyticsEventsRepositoryType } from '../ITipAnalyticsEventsRepository';
import { ICoordinatorServiceType } from '../../../Services/CoordinatorService/ICoordinatorService';
import { parseChoiceItems } from '../../../../Helpers/ParseChoiceItems';
let SendTipUseCase = class SendTipUseCase {
    constructor(repository, payloadRepository, coordinatorService, continueUseCase, setTipOptions, eventsRepository, getSelectedChoiceItem, analyticsRepository) {
        this.repository = repository;
        this.payloadRepository = payloadRepository;
        this.coordinatorService = coordinatorService;
        this.continueUseCase = continueUseCase;
        this.setTipOptions = setTipOptions;
        this.eventsRepository = eventsRepository;
        this.getSelectedChoiceItem = getSelectedChoiceItem;
        this.analyticsRepository = analyticsRepository;
    }
    execute() {
        var _a;
        const tip = this.repository.tip.value;
        const item = (_a = tip.choice_items) === null || _a === void 0 ? void 0 : _a.find(item => item.value === 1);
        if (!item) {
            return Promise.reject(new Error('No selected tip!'));
        }
        let hasError = false;
        if (item === null || item === void 0 ? void 0 : item.choice_items) {
            item.choice_items = item.choice_items.map(item => {
                var _a, _b;
                item.error = typeof item.min_value === 'number' && Number(item.value) < item.min_value
                    ? ((_a = item.customize) === null || _a === void 0 ? void 0 : _a.minimum_validation_error_message) || `Minimum value is ${item.min_value}`
                    : undefined;
                if (!item.error && typeof item.max_value === 'number' && Number(item.value) > item.max_value) {
                    item.error = ((_b = item.customize) === null || _b === void 0 ? void 0 : _b.maximum_validation_error_message) || `Maximum value is ${item.max_value}`;
                }
                hasError = !!item.error;
                return item;
            });
        }
        if (hasError) {
            this.setTipOptions.execute(tip.choice_items || []);
            return Promise.resolve(this.repository.tip);
        }
        const choiceUpdate = {
            id: tip.id,
            choice_items: parseChoiceItems(tip.choice_items || [])
        };
        if (!this.payloadRepository.getBookingID().value) {
            this.eventsRepository.sendDidTipEvent(choiceUpdate);
            this.continueUseCase.execute();
            return Promise.resolve(this.repository.tip);
        }
        const { value, type, booking_transaction_id, position, booking_id } = this.getSelectedChoiceItem.execute(tip.choice_items || []);
        const analyticEvent = { value, type, booking_transaction_id, position, booking_id };
        this.analyticsRepository.sendTipSubmittedEvent(analyticEvent);
        return this.repository.sendTip(this.payloadRepository.getBookingID().value, item)
            .then(response => {
            this.eventsRepository.sendDidTipEvent(choiceUpdate);
            this.analyticsRepository.sendTipSuccessEvent(analyticEvent);
            if (!this.payloadRepository.getShowSuccessPage().value) {
                this.continueUseCase.execute();
                return this.repository.tip;
            }
            const tip = Object.assign(Object.assign({}, this.repository.tip.value), { customize: Object.assign(Object.assign({}, this.repository.tip.value.customize), { tipped: true, status_message: response.message, status: response.type }) });
            this.repository.setTip(tip);
            return this.coordinatorService.navigateToStatus().then(() => this.repository.tip);
        })
            .catch(error => {
            this.repository.setTip(Object.assign(Object.assign({}, this.repository.tip.value), { customize: Object.assign(Object.assign({}, this.repository.tip.value.customize), { status_message: error.message, status: 'error' }) }));
            this.analyticsRepository.sendTipFailedEvent(Object.assign(Object.assign({}, analyticEvent), { message: error.message }));
            return this.coordinatorService.navigateToStatus().then(() => this.repository.tip);
        });
    }
};
SendTipUseCase = __decorate([
    injectable(),
    __param(0, inject(ITipRepositoryType)),
    __param(1, inject(ITipPayloadRepositoryType)),
    __param(2, inject(ICoordinatorServiceType)),
    __param(3, inject(IContinueUseCaseType)),
    __param(4, inject(ISetTipOptionUseCaseType)),
    __param(5, inject(ITipEventsRepositoryType)),
    __param(6, inject(IGetAnalyticEventParamsUseCaseType)),
    __param(7, inject(ITipAnalyticsEventsRepositoryType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object])
], SendTipUseCase);
export { SendTipUseCase };
